export enum StoreNameEnum {
	FINTECH_REGISTER = "FINTECH_REGISTER",
	ANTICIPATION = "ANTICIPATION",
	PAYMENT_INFO = "PAYMENT_INFO",
	PARTIAL_ANTICIPATION = "PARTIAL_ANTICIPATION",
	LAST_ROUTE = "LAST_ROUTE",
}
